const ZONE_TYPES = {
  EPIC: 'EPIC',
  DEPENDENCY: 'DEPENDENCY',
  GANTT: 'GANTT',
};

export default ZONE_TYPES;
